/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_515Inputs */

const vi_carrier_status_515 = /** @type {(inputs: Carrier_Status_515Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duyệt hoàn`)
};

/**

* @param {Carrier_Status_515Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_515 = /** @type {((inputs?: Carrier_Status_515Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_515Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_515(inputs)
});